// extracted by mini-css-extract-plugin
module.exports = {"container":"e_D-","icon":"e_E-"};